import PurchaseAccountForm from "../../components/AccountComponents/PurchaseAccountForm";

function NewPurchaseAccountPage() {
  return <PurchaseAccountForm method="post" title="Purchase" />;
}

export default NewPurchaseAccountPage;
